import React from 'react'
import { useTranslation } from 'react-i18next'
import { TreatmentUpsellDetails } from '@customTypes/TreatmentUpsellDetails'
import { Button } from '@components/Button/Button'
import Footer from '@components/Footer'
import Header from '@components/Header'
import Page from '@components/Page'
import { Body } from './Body'
import useStyles from './styles'
import { TEST_IDS } from 'src/constants/testIds'

interface Props {
  upsellDetails: TreatmentUpsellDetails
  onBackClick: () => void
  continueWithoutUpsell: () => void
  continueWithUpsell: () => void
}

export const UpsellTreatmentScreen = ({
  upsellDetails,
  onBackClick,
  continueWithoutUpsell,
  continueWithUpsell,
}: Props) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { upsellHeadlineTranslationKey, primaryCtaKey, secondaryCtaKey } = upsellDetails

  return (
    <Page
      header={
        <Header
          desktopHeadingText={t(upsellHeadlineTranslationKey)}
          mobileHeadingText={t(upsellHeadlineTranslationKey)}
          onBackClick={onBackClick}
        />
      }
      body={<Body upsellDetails={upsellDetails} />}
      footer={
        <Footer button={null}>
          <div className={classes.footerContainer}>
            <Button
              variant="borderless"
              fullSize
              type="button"
              data-test={TEST_IDS.nextButton}
              text={t(secondaryCtaKey)}
              size="md"
              onClick={continueWithoutUpsell}
            />
            <Button
              fullSize
              type="button"
              data-test={TEST_IDS.nextButton}
              text={t(primaryCtaKey)}
              size="lg"
              className={classes.primaryCta}
              onClick={continueWithUpsell}
            />
          </div>
        </Footer>
      }
    />
  )
}
